import React, { Fragment } from "react";
import { useParams } from "react-router-dom";
//
import { useForm } from "react-hook-form";
//
import { useQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
//
import Snackbar from "@material-ui/core/Snackbar";
import Typography from "@material-ui/core/Typography";
import DialogForm from "components/buttonDialogForm";
import FormField from "components/formField";
import PictureAsPdfOutlinedIcon from '@material-ui/icons/PictureAsPdfOutlined';

export const GET_COOPERATIVE_NAME = gql`
  query GetCooperative($id: ID!) {
    cooperative(id: $id) {
      businessName
    }
  }
`;

export const EXPORT_ATTENDANCE = gql`
  mutation ExportAttendance($input: ExportAttendanceInput!) {
    exportAttendance(
      input: $input
    ) {
      code
      success
      message
    }
  }  
`;

export default function ({ attendance }) {
  const { id } = useParams();

  const {
    data: queryData,
    loading: queryLoading,
    error: queryError
  } = useQuery(GET_COOPERATIVE_NAME, {
    variables: { id }
  });

  const [
    exportAttendance,
    { data: mutationData, loading: mutationLoading, error: mutationError }
  ] = useMutation(EXPORT_ATTENDANCE);

  const { register, control, handleSubmit, formState, errors } = useForm({
    //mode: "onChange"
  });

  const onSubmit = data => {
    const { contractSector, onlySummary } = data;

    const variables = {
      input: {
        //cooperative: queryData.cooperative.businessName
        id: attendance.id,
        contractSector,
        onlySummary
      }
    };

    exportAttendance({
      variables
    });
  };

  if (queryError) return <p>ERROR: {queryError.message}</p>;

  return (
    <Fragment>
      <Snackbar
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        open={mutationLoading}
        message={"Esportazione delle presenze avviata con successo."}
      />
      <Snackbar
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        open={Boolean(mutationError)}
        message={"Si è verificato un errore nell'esportazione delle presenze"}
      />
      <DialogForm
        id="export-attendance"
        title={
          queryData &&
          `Esportazione Presenze ${queryData.cooperative.businessName}`
        }
        subTitle={queryData && `La seguente procedura avvierà l'esportazione delle presenze per la società ${queryData.cooperative.businessName}, partendo dalle presenze ${attendance.title}.`}
        buttonTitle='Esporta presenze'
        formState={formState}
        icon={PictureAsPdfOutlinedIcon}
        onSubmit={handleSubmit(onSubmit)}
      >
        {/* <FormField
            id="code"
            name="code"
            label="Codice"
            type="text"
            inputRef={register({ required: "Inserisci il codice." })}
            error={errors.password}
          />
          <FormField
            id="stip"
            name="agreementDate"
            label="Data stipula"
            type="date"
            inputRef={register({ required: "Inserisci data di stipula." })}
            error={errors.password}
          />
          <FormField
            id="start"
            name="startDate"
            label="Data inizio"
            type="date"
            inputRef={register({ required: "Inserisci data di inizio." })}
            error={errors.password}
          /> */}
          { true && <FormField
            id="contractSector"
            name="contractSector"
            label="Settore contratto"
            type="text"
            //inputRef={register({ required: "Inserisci il codice." })}
            control={control}
            error={errors.password}
          />}          
          { true && <FormField
            id="onlySummary"
            name="onlySummary"
            label="Solo sommario"
            type="switch"
            //inputRef={register()}
            control={control}
            error={errors.password}
          /> }           
      </DialogForm>
    </Fragment>
  );
}
